import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      num:0
  },
  mutations: {
    changenum(){
      this.state.num = !this.state.num - 0
    }
  },
  actions: {
  },
  modules: {
  }
})
